import { c as _c } from "react/compiler-runtime";
import { useInterval } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useCallback, useMemo, useState } from 'react';
const UNITS_IN_MILLISECS = {
  year: 31536000000,
  month: 2628000000,
  day: 86400000,
  hour: 3600000,
  minute: 60000,
  second: 1000
} as const;
const LOCALIZED_RFT = {
  de: new Intl.RelativeTimeFormat('de', {
    numeric: 'auto'
  }),
  en: new Intl.RelativeTimeFormat('en', {
    numeric: 'auto'
  })
} as const;
function useRelativeTimeFromTimestamp(timestamp) {
  const $ = _c(12);
  const locale = useLocale();
  const t = useTranslations("nextjs.core");
  let t0;
  if ($[0] !== timestamp) {
    t0 = new Date(timestamp).getTime();
    $[0] = timestamp;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const timestampTime = t0;
  const [elapsedTime, setElapsedTime] = useState(null);
  let t1;
  if ($[2] !== timestampTime) {
    t1 = () => {
      setElapsedTime(Date.now() - timestampTime);
    };
    $[2] = timestampTime;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateElapsedTime = t1;
  let t2;
  if ($[4] !== updateElapsedTime) {
    t2 = {
      callback: updateElapsedTime,
      intervalMs: 10000,
      executeImmediately: true
    };
    $[4] = updateElapsedTime;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useInterval(t2);
  let t3;
  if ($[6] !== elapsedTime || $[7] !== locale || $[8] !== t) {
    bb0: {
      if (elapsedTime === null) {
        t3 = "";
        break bb0;
      }
      if (elapsedTime < UNITS_IN_MILLISECS.minute) {
        let t4;
        if ($[10] !== t) {
          t4 = t("just_now");
          $[10] = t;
          $[11] = t4;
        } else {
          t4 = $[11];
        }
        t3 = t4;
        break bb0;
      }
      const unit = Object.keys(UNITS_IN_MILLISECS).find(key => elapsedTime >= UNITS_IN_MILLISECS[key as keyof typeof UNITS_IN_MILLISECS]) as keyof typeof UNITS_IN_MILLISECS;
      const value = -Math.round(elapsedTime / UNITS_IN_MILLISECS[unit]);
      if (typeof value !== "number" || isNaN(value)) {
        console.error("Invalid value", {
          relativeTimestamp: value
        });
        t3 = "";
        break bb0;
      }
      t3 = LOCALIZED_RFT[locale].format(value, unit);
    }
    $[6] = elapsedTime;
    $[7] = locale;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const relativeTimestamp = t3;
  return relativeTimestamp;
}
export default useRelativeTimeFromTimestamp;